import React, { useMemo } from 'react'
import { ListPoliciesRequest } from '@trustero/trustero-api-web/lib/model/policy_pb'
import { BoolValue } from 'google-protobuf/google/protobuf/wrappers_pb'
import { usePolicies } from 'src/components/async/policy/usePolicies'
import { FilterName, FilterParam } from '../FilterBar.types'
import { NONE_VALUE } from '../FilterBar.constants'
import { FilterDropdown } from './FilterDropdown'
import { DropdownItemType } from './FilterDropdown.constants'

export const PolicyFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const request = useMemo(
      () =>
        new ListPoliciesRequest().setIsDismissed(
          new BoolValue().setValue(false),
        ),
      [],
    )
    const { data, isLoading, error } = usePolicies(request)
    const filterValues = useMemo<DropdownItemType[]>(
      () => [
        NONE_VALUE,
        ...(data?.getItemsList() ?? []).map((policy) => ({
          value: policy.getModelId(),
          label: policy.getName(),
        })),
      ],
      [data],
    )
    if (error) return <></>

    return (
      <FilterDropdown
        filterParam={FilterParam.POLICY}
        filterName={FilterName.POLICY}
        filterValues={filterValues}
        isLoading={!data || isLoading}
        isNested={isNested}
      />
    )
  },
)
